import { IVeriListRow } from "@directives/_veri/veriList/veriList.component";
import { IComboBox } from "@interfaces/IComboBox";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { copy } from "angular";
import "./resourceGroupList.component.scss";

interface IGroupListBindings {
    items: any[];
    updateTrigger: any;

    createEntityCallback: (args: { entity: any, newInclusionState?: boolean }) => IResourceGroupListEntry<any>;
    onIncludedItemChanged: (args: { item: IResourceGroupListEntry<any> }) => void;
}

export interface IResourceGroupListEntry<T> {
    id: number;
    title: string;
    subTitle?: string;
    included: boolean;
    includedForFilter?: boolean;
    customIcon?: string;
    customClass?: string;

    data: T;
    disabled?: boolean;
}

enum Filter {
    All,
    Included,
    NotIncluded,
    IncludedInGroup,
    IncludedInSubGroup
}

export class GroupListComponentController implements IGroupListBindings {
    maxSelectedItems: number;
    listLabel: string;
    listItemLabel: string;

    items: any[] = [];
    updateTrigger: any;

    rows: IVeriListRow<IResourceGroupListEntry<any>>[] = [];

    dropDownfilterOptions: IComboBox[] = [];

    numIncluded = 0;

    createSearchCallback: (args: { entity: any }) => string;
    createEntityCallback: (args: { entity: any, newInclusionState?: boolean }) => IResourceGroupListEntry<any>;
    onIncludedItemChanged: (args: { item: IResourceGroupListEntry<any> }) => void;

    static $inject = ["translationService"];

    constructor(private readonly translationService: TranslationService) {
    }

    $onInit() {
        this.dropDownfilterOptions = [];

        this.dropDownfilterOptions.push({ Name: this.translationService.t("groupList.included"), Value: Filter.Included });
        this.dropDownfilterOptions.push({ Name: this.translationService.t("groupList.notIncluded"), Value: Filter.NotIncluded });
    }

    $onChanges(onChangesObj: angular.IOnChangesObject): void {

        if (onChangesObj["updateTrigger"]) {
            this.createRows();
        }
    }

    rowClicked(entry: IResourceGroupListEntry<any>) {
        console.warn("rowClicked", entry);
        entry = this.createEntityCallback({ entity: entry.data, newInclusionState: !entry.included });

        if (entry.included) {
            this.numIncluded++;
        }
        else {
            this.numIncluded--;
        }

        let rowDataUpdated = false;

        for (var i = 0; i < this.rows.length; i++) {
            const row = this.rows[i];

            if (row.data.id == entry.id) {
                row.data = entry;
                row.className = entry.customClass;
                if (entry.disabled && !row.className.includes('disabled')) {
                    row.className += " disabled";
                }
                row.filterData = this.createRowFilterData(entry);
                rowDataUpdated = true;

                if (this.onIncludedItemChanged) {
                    this.onIncludedItemChanged({ item: entry });
                }

                break;
            }
        }

        if (!rowDataUpdated) {
            return;
        }

        this.rows = copy(this.rows);
    }

    customRowSorter(row1: IVeriListRow<IResourceGroupListEntry<any>>, row2: IVeriListRow<IResourceGroupListEntry<any>>): number {
        if (row1.data.includedForFilter && row2.data.includedForFilter) {
            return 0;
        }
        else if (row1.data.includedForFilter) { return -1; }
        else if (row2.data.includedForFilter) { return 1; }

        return null;
    }

    removeAll() {
        this.setRowStateForAll(false);
    }

    addAll() {
        this.setRowStateForAll(true);
    }

    // --

    private setRowStateForAll(newState: boolean) {
        this.numIncluded = 0;

        for (var i = 0; i < this.rows.length; i++) {
            const row = this.rows[i];
            var entry = row.data as IResourceGroupListEntry<any>;

            if (entry && entry.included != newState) {
                entry = this.createEntityCallback({ entity: entry.data, newInclusionState: newState });
                row.data = entry;

                row.filterData = this.createRowFilterData(entry);

                if (this.onIncludedItemChanged) {
                    this.onIncludedItemChanged({ item: entry });
                }
            }

            if (entry.included) {
                this.numIncluded++;
            }
        }

        this.rows = this.rows.slice();
    }

    private createRowFilterData(rowEntity: IResourceGroupListEntry<any>): number[] {
        var filterData: number[] = [Filter.All];

        if (rowEntity.included || rowEntity.includedForFilter) {
            filterData.push(Filter.Included);
        }
        else {
            filterData.push(Filter.NotIncluded);
        }

        return filterData;
    }

    private createRows() {
        this.rows = [];

        if (!this.createEntityCallback) {
            console.error("createEntityCallback required!");
            return;
        }

        if (!this.items) {
            console.error("Items required!");
            return;
        }

        this.numIncluded = 0;
        this.items.forEach(entity => {

            var searchString = this.createSearchCallback?.({ entity: entity });

            var rowEntity = this.createEntityCallback({ entity: entity });
            var filterData = this.createRowFilterData(rowEntity);

            var row: IVeriListRow<any> = {
                contents: rowEntity.title,
                data: rowEntity,
                sortData: rowEntity.title,
                id: rowEntity.id,
                filterData: filterData,
                className: rowEntity.customClass,
                searchString: searchString
            };

            if (rowEntity.disabled) {
                row.className += " disabled";
            }

            this.rows.push(row);

            if (rowEntity.included) {
                this.numIncluded++;
            }
        });
    }
}

export class GroupListComponent implements angular.IComponentOptions {

    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {

            maxSelectedItems: "<",
            listLabel: "@",
            listItemLabel: "@",
            
            hideAddAll: "<",

            updateTrigger: "<",
            items: "<",

            createSearchCallback: "&",
            createEntityCallback: "&",
            onIncludedItemChanged: "&",
        };

        this.controller = GroupListComponentController;
        this.template = require("./resourceGroupList.component.html");
    }

}
